import * as React from 'react';

import {
  ContextMenuContext,
  useContextMenuValue,
} from 'src/containers/ProjectDiagram/hooks/useContextMenuValue';
import {
  SelectionContext,
  useDiagramSelectionValue,
} from 'src/containers/ProjectDiagram/hooks/useDiagramSelectionValue';
import {
  DiagramContext,
  useDiagramValue,
} from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { useHandleDiagramUpdate } from 'src/containers/ProjectDiagram/hooks/useHandleDiagramUpdate';
import {
  TooltipContext,
  useTooltipValue,
} from 'src/containers/ProjectDiagram/hooks/useTooltipValue';
import { useUpdateDiagramData } from 'src/containers/ProjectDiagram/hooks/useUpdateDiagramData';
import { useDiagramSnapshot } from 'src/utils/hooks/useDiagramSnapshot';

type ProjectDiagramContextProviderProps = {
  children: React.ReactNode;
};

export const ProjectDiagramContextProvider: React.VFC<
  ProjectDiagramContextProviderProps
> = ({ children }) => {
  const handleDiagramUpdate = useHandleDiagramUpdate();
  const diagramSnapshot = useDiagramSnapshot();

  const contextMenuValue = useContextMenuValue();
  const selectionValue = useDiagramSelectionValue();
  const tooltipValue = useTooltipValue();

  const [, setContextMenu] = contextMenuValue;
  const [, setSelection] = selectionValue;
  const [, setTooltip] = tooltipValue;

  const handleDiagramSelection = React.useCallback(
    (selection: go.Set<go.Part>) => {
      setSelection(selection.copy());
    },
    [setSelection]
  );

  // setup diagram
  const diagram = useDiagramValue({
    diagramSnapshot,
    handleDiagramUpdate,
    handleDiagramSelection,
    setContextMenu,
    setTooltip,
  });

  useUpdateDiagramData(diagram);

  return (
    <DiagramContext.Provider value={diagram}>
      <ContextMenuContext.Provider value={contextMenuValue}>
        <SelectionContext.Provider value={selectionValue}>
          <TooltipContext.Provider value={tooltipValue}>
            {children}
          </TooltipContext.Provider>
        </SelectionContext.Provider>
      </ContextMenuContext.Provider>
    </DiagramContext.Provider>
  );
};
